import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as Icon from 'ubs-icons';
import {sendData} from '../../store/actions';
import useSocket from '../common/useSocket';

const WorkspaceRedirect = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const _IA = useSelector(e => e.common.isAuthenticated);

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'getWorkspaceList': {
                    off();
                    const orgId = res.data?.activeOrgId || res.data?.list?.[0]?.orgId;
                    if (orgId) {
                        history.replace(`/${orgId}/manage/workspace`);
                    }
                    break;
                }
                default:
                    return true;
            }
        }
    });

    useEffect(() => {
        refresh();
        return () => off();
    }, []);

    useEffect(() => {
        if (_IA) sendData(dispatch, 'getWorkspaceList', {requirePlanDetails: true});
    }, [_IA]);

    return (
        <div className="u_preloader"><Icon.Preloader/></div>
    );
};

export default WorkspaceRedirect;
